package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.domain.legal.LegalCalendarYear
import com.evoapps.evoshift.domain.repository.LegalCalendarRepository
import com.evoapps.evoshift.data.remote.AppFirestore

/**
 * `legal_calendars/{country}_{year}` (SH-55): the statutory trading Sundays and holidays, the same
 * JSON as firebase/legal/{country}/{year}.json (seeded by scripts/legal/seed_legal_calendar.js).
 * Read-only for the app (firestore.rules); offline, Firestore's cache answers, and without a cached
 * copy the read fails and GetDayClosuresUseCase uses the copy shipped with the app.
 */
class LegalCalendarRepositoryImpl(private val firestore: AppFirestore) : LegalCalendarRepository {
    override suspend fun getYear(country: String, year: Int): Result<LegalCalendarYear?> = runCatching {
        val snapshot = firestore.collection(COLLECTION).document(LegalCalendarYear.documentId(country, year)).get()
        if (!snapshot.exists) null else snapshot.data<LegalCalendarYear>()
    }

    companion object {
        const val COLLECTION = "legal_calendars"
    }
}
